import React, { useRef } from "react";
import Button from "components/common/Button";
import PopupModal, { PopupModalRef } from "components/common/PopupModal";
import ModalContent from "components/modals/ModalContent";
import BookingService from "services/booking";
import { useNotification } from "hooks/useNotification";
import { get } from "utils/lodash";
import { CheckCircle } from "lucide-react";

interface DoneBookingProps {
  booking: any;
  onSuccess?: (res?: any) => void;
  className?: string;
}

export default function DoneBooking({ booking, onSuccess, className }: DoneBookingProps) {
  const modalRef = useRef<PopupModalRef>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const notification = useNotification();
  const bookingId = get(booking, "id", "");

  const customerName = get(booking, "populatedUser[0].name") ||
                      get(booking, "user.name") ||
                      "khách hàng";

  const handleDone = async () => {
    try {
      setIsLoading(true);
      const res = await BookingService.doneBooking({ id: bookingId });
      notification.success("Hoàn thành lịch hẹn");
      modalRef.current?.close();
      onSuccess?.(res);
    } catch (error) {
      notification.error("Hoàn thành lịch hẹn thất bại");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        className={className}
        variant="success"
        size="sm"
        loading={isLoading}
        onClick={(e: any) => {
          e.stopPropagation();
          modalRef.current?.open();
        }}
      >
        <span className="font-semibold">Hoàn thành</span>
      </Button>
      <PopupModal ref={modalRef}>
        <ModalContent
          content={
            <div className="flex flex-col items-center gap-4">
              <CheckCircle className="w-12 h-12 text-green-500" />
              <label className="text-center">
                Xác nhận hoàn thành dịch vụ cho khách hàng{" "}
                <span className="font-semibold">{customerName}</span>?
              </label>
            </div>
          }
          closable
          cancelLabel="Hủy"
          acceptLabel="Xác nhận hoàn thành"
          onAccept={handleDone}
          onCancel={() => modalRef.current?.close()}
        />
      </PopupModal>
    </>
  );
}